import moment from 'moment';

import {
    CLEAR_MESSAGE, CLEAR_MESSAGE_ERROR, EMPTY_MESSAGING,
    FETCH_CONVERSATIONS, FETCH_CONVERSATIONS_SUCCESS, FETCH_CONVERSATIONS_FAILURE,
    FETCH_MESSAGES, FETCH_MESSAGES_SUCCESS, FETCH_MESSAGES_FAILURE,
    MARK_CONVERSATION_READ, MARK_CONVERSATION_READ_SUCCESS, MARK_CONVERSATION_READ_FAILURE,
    SEND_MESSAGE, SEND_MESSAGE_SUCCESS, SEND_MESSAGE_FAILURE,
    SET_CONVERSATION, SET_MESSAGE, SET_SUBJECT
} from './constants';
import Request from 'utils/request';
import {PATHS} from "../../../utils/paths";

//import { request, requestConfig } from 'utils/request';

export const clearMessage = () => ({
    type: CLEAR_MESSAGE
});

export const clearMessageError = () => ({
    type: CLEAR_MESSAGE_ERROR
});

export const emptyMessaging = () => ({
    type: EMPTY_MESSAGING
});

const fetchConversations = (hideSpinner) => ({
    type: FETCH_CONVERSATIONS,
    hideSpinner
});

const fetchConversationsSuccess = (data, hasUnreadMessages) => ({
    type: FETCH_CONVERSATIONS_SUCCESS,
    data,
    hasUnreadMessages
});

const fetchConversationsFailure = (error) => ({
    type: FETCH_CONVERSATIONS_FAILURE,
    error
});

const fetchMessages = (hideSpinner) => ({
    type: FETCH_MESSAGES,
    hideSpinner
});

const fetchMessagesSuccess = (data) => ({
    type: FETCH_MESSAGES_SUCCESS,
    data
});

const fetchMessagesFailure = (error) => ({
    type: FETCH_MESSAGES_FAILURE,
    error
});

const markConversationRead = () => ({
    type: MARK_CONVERSATION_READ
});

const markConversationReadSuccess = () => ({
    type: MARK_CONVERSATION_READ_SUCCESS
});

const markConversationReadFailure = (error) => ({
    type: MARK_CONVERSATION_READ_FAILURE,
    error
});

const sendMessage = () => ({
    type: SEND_MESSAGE
});

const sendMessageSuccess = () => ({
    type: SEND_MESSAGE_SUCCESS
});

const sendMessageFailure = (error) => ({
    type: SEND_MESSAGE_FAILURE,
    error
});

export const setConversation = (data) => ({
    type: SET_CONVERSATION,
    data
});

export const setMessage = (data) => ({
    type: SET_MESSAGE,
    data
});

export const setSubject = (data) => ({
    type: SET_SUBJECT,
    data
});


/**
 *  ASYNC ACTIONS
 */

export const getConversations = (hideSpinner) => (dispatch, getStore) => {
    dispatch(fetchConversations(hideSpinner));

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.messages.getAllConversations())
        .then((response) => {
            let hasUnread = response.data.data.filter((conversation) => conversation.hasUnreadMessages === true).length > 0;
            dispatch(fetchConversationsSuccess(response.data.data, hasUnread));
            return response;
        })
        .catch((error) => {
            console.log('getConversations error', error, error.response);
            error.friendlyMessage = 'There was an error getting conversations. Please try again.';
            dispatch(fetchConversationsFailure(error));
            throw error;
        });
};

export const getMessages = (hideSpinner) => (dispatch, getStore) => {
    dispatch(fetchMessages(hideSpinner));

    let request = new Request(getStore().auth.token);

    return request.get(PATHS.messages.getMessagesInConversation(getStore().messaging.conversation.id))
        .then((response) => {
            let messages = {};
            response.data.data.forEach((message) => {
                let formattedDate = moment(message.created_at).format('YYYY-MM-DD');
                if(messages[formattedDate] == null) {
                    messages[formattedDate] = [];
                }
                //console.log(formattedDate, message)
                messages[formattedDate].push(message);
            });

            let finalMessagesArray = [];

            Object.keys(messages).forEach((key) => {
                let msgObj = {
                    date: key,
                    messages: messages[key]
                };

                finalMessagesArray.push(msgObj);
            });

            //finalMessagesArray.reverse();

            dispatch(fetchMessagesSuccess(finalMessagesArray));
            return response;
        })
        .catch((error) => {
            console.log('getMessages error', error, error.response);
            error.friendlyMessage = 'There was an error getting messages in this conversation. Please try again.';
            dispatch(fetchMessagesFailure(error));
            throw error;
        });
};

export const postConversation = (profiles) => (dispatch, getStore) => {
    dispatch(sendMessage());

    let messageText = getStore().messaging.message;

    let message = {
        subject: getStore().messaging.subject,
        message: {
            parts: []
        }
    };

    messageText.split(/\n/).forEach((part) => {
        if(part) {
            message.message.parts.push({
                mimeType: 'string',
                body: part
            });
        }
    });

    if(getStore().opportunities.opportunity.id != null) {
        message.recipientCompanyId = getStore().opportunities.opportunity.company.id;
    } else if(getStore().accounts.company.id && !getStore().auth.user.company) {
        message.recipientCompanyId = getStore().accounts.company.id;
    } else if(profiles && profiles.length > 0) {
        message.recipientUserIds = profiles.map((p) => p.id);
    } else {
        message.recipientUserId = getStore().accounts.user.id;
    }

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.messages.createConversation(), message)
        .then((response) => {
            dispatch(sendMessageSuccess());
            return response;
        })
        .catch((error) => {
            console.log('postConversation error', error, error.response);
            error.friendlyMessage = 'There was an error sending your message. Please try again.';
            dispatch(sendMessageFailure(error));
            throw error;
        });
};

export const postConversationAsRead = () => (dispatch, getStore) => {
    dispatch(markConversationRead());
    let conversationId = getStore().messaging.conversation.id;

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.messages.markConversationAsRead(conversationId))
        .then((response) => {
            dispatch(markConversationReadSuccess());
            dispatch(getConversations(true));
            return response;
        })
        .catch((error) => {
            console.log('postConversationAsRead error', error, error.response);
            error.friendlyMessage = 'There was an error sending your message. Please try again.';
            dispatch(markConversationReadFailure(error));
            throw error;
        });
};

export const postMessage = () => (dispatch, getStore) => {
    dispatch(sendMessage());

    let messageText = getStore().messaging.message;

    let message = {
        parts: []
    };

    messageText.split(/\n/).forEach((part) => {
        if(part) {
            message.parts.push({
                mimeType: 'string',
                body: part
            });
        }
    });

    let request = new Request(getStore().auth.token);

    return request.post(PATHS.messages.sendMessageInConversation(getStore().messaging.conversation.id), message)
        .then((response) => {
            dispatch(sendMessageSuccess());
            return response;
        })
        .catch((error) => {
            console.log('postMessage error', error, error.response);
            error.friendlyMessage = 'There was an error sending your message. Please try again.';
            dispatch(sendMessageFailure(error));
            throw error;
        });
};




// WEBPACK FOOTER //
// ./src/containers/Messaging/store/actions.js